"use client";

import Script from "next/script";
import { useState } from "react";

interface TransUnionScriptsProps {
  configSrc: string;
  loaderSrc: string;
}

export default function TransUnionScripts({ configSrc, loaderSrc }: TransUnionScriptsProps) {
  const [configLoaded, setConfigLoaded] = useState(false);

  return (
    <>
      <Script src={configSrc} onLoad={() => setConfigLoaded(true)} />
      {configLoaded && <Script src={loaderSrc} />}
    </>
  );
}
